import styled from 'styled-components';

export const StyledLogo = styled.img`
  height: 77px;
  box-shadow: rgba(60, 64, 67, 0.3) 0px 1px 2px 0px,
    rgba(60, 64, 67, 0.15) 0px 2px 6px 2px;
  padding: 7px;
  border-radius: 50%;
`;
